module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Right.a60f8c08.svg";